import { render, staticRenderFns } from "./Moments.vue?vue&type=template&id=3bfa9fba&"
import script from "./Moments.vue?vue&type=script&lang=js&"
export * from "./Moments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports